import React from "react";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import Slider from "react-slick";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { returnImgSrc } from "@utils/helpers";
import SectionHeaders from "@containers/HomePage/components/ui/SectionHeaders";

export function SliderNextArrow(props) {
  const { onClick } = props;
  return (
    <button
      title='Previous'
      className='absolute top-1/2 right-0 -mt-6 -mr-2 bg-white w-10 h-12 hidden lg:flex items-center justify-center shadow-lg border border-gray-300 z-10 cursor-pointer'
      onClick={onClick}
    >
      <RiArrowRightSLine className='text-black text-3xl' />
    </button>
  );
}

export function SliderPrevArrow(props) {
  const { onClick } = props;
  return (
    <button
      title='Next'
      className='absolute top-1/2 left-0 -mt-6 -ml-2 bg-white w-10 h-12 hidden lg:flex items-center justify-center shadow-lg border border-gray-300 z-10 cursor-pointer'
      onClick={onClick}
    >
      <RiArrowLeftSLine className='text-black text-3xl' />
    </button>
  );
}

const SliderSection = ({ section_data }) => {
  if (section_data && section_data?.data?.images?.length > 0) {
    // if (section_data.view_type === "Slider") {
    const slider_setting = section_data.data.slider_setting;
    const returnSliderSettings = () => {
      let settings = {};
      try {
        if (
          slider_setting?.extra_setting &&
          typeof slider_setting.extra_setting === "string"
        ) {
          settings = JSON.parse(slider_setting.extra_setting);
        }
      } catch (err) {
        settings = {};
      }

      return {
        ...slider_setting,
        ...settings,
        nextArrow: <SliderNextArrow />,
        prevArrow: <SliderPrevArrow />,
      };
    };

    return (
      <>
        <div className={`${section_data.layout_class || "mx-auto"} `}>
          {section_data.is_header && (
            <SectionHeaders
              title={
                section_data.data.slider_name ||
                section_data.content_section?.name
              }
            />
          )}
          <Slider {...returnSliderSettings()}>
            {section_data.data.images.map((image) => (
              <Fragment key={image._id}>
                {image?.image?.path ? (
                  <>
                    {image?.link !== "" ? (
                      <Link to={image.link ? image.link : ""} target='_blank'>
                        <img
                          src={returnImgSrc(image.image)}
                          alt='Carousel-Image'
                          className='w-full'
                        />
                      </Link>
                    ) : (
                      <img
                        src={returnImgSrc(image.image)}
                        alt='Carousel-Image'
                        className='w-full'
                      />
                    )}
                  </>
                ) : (
                  <div
                    className='w-full ckEditor absolute transform left-1/2 top-1/2 -translate-1/2 -translate-1/2'
                    dangerouslySetInnerHTML={{
                      __html: image.caption,
                    }}
                  />
                )}
              </Fragment>
            ))}
          </Slider>
        </div>
      </>
    );
    // }
  }

  return <div>SliderSection</div>;
};

export default SliderSection;
